var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('talmundo-switch',{attrs:{"id":"disableManualInput","label":_vm.$t('forms.date.disableManualInput')},on:{"change":function($event){return _vm.changeType($event, 'disableManualInput')}},model:{value:(_vm.disableManualInput),callback:function ($$v) {_vm.disableManualInput=$$v},expression:"disableManualInput"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }